module.exports = "<symbol id=\"thebestco-uikit-svg-LeftThin16\" viewBox=\"0 0 18 18\"><path d=\"M13 1L5 9L13 17\"/></symbol>";